import { contactsMockedData } from './mockedData/contactsMockedData';

export class ContactsMock {
    find(things) {
        console.log('this is the mock :D', contactsMockedData);
        return Promise.resolve(contactsMockedData);
    }
}
